import { render } from "./SerialEnd.vue?vue&type=template&id=18c71124"
import script from "./SerialEnd.vue?vue&type=script&lang=js"
export * from "./SerialEnd.vue?vue&type=script&lang=js"
script.render = render

export default script